export default function getInitState() {
    return {
        patientEvidenceNonValidatedDocumentsDataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        patientEvidenceNonValidatedDocumentsRowActions: [
            {
                btn_text: '<i class="fas fa-arrow-right"></i>',
                title: 'Kiválasztás',
                event_name: "customClick",
                class: "btn btn-outline-primary",
                event_payload: 'selectDocument'
            },
        ],
        patientEvidenceNonValidatedDocumentsActions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        patientEvidenceNonValidatedDocumentsHeaderFields: [
            {
                name: "clinic.text",
                label: "Szakrendelés",
                visibility: true,
            },
            {
                name: "primaryBno.leiras",
                label: "Fődiagnózis",
                visibility: true,
                formType: 'select',
                formVisible: true,
            },
            {
                name: "buttons",
                label: "Opciók"
            }
        ]
    }
}
